import * as React from 'react';
import type {IEventTemplate} from '../../../types/IEventTemplate';
import type {SequenceItem} from '../../../types/IEventTemplateMetadata';
import useLabelTranslation from 'src/hooks/useLabelTranslation';
import {Timeline} from '@spaced-out/ui-design-system/lib/components/Timeline';
import {RoundTimelineItem} from './round-timeline-item';
import {BreakTimelineItem} from './break-timeline-item';


interface SequenceDayItemProps {
  sequenceDay: SequenceItem;
  eventTemplate: IEventTemplate;
}

export const SequenceDayItem = ({
  sequenceDay,
  eventTemplate,
}: SequenceDayItemProps) => {
  const {t} = useLabelTranslation();

  if (sequenceDay.type !== 'day') {
    return null;
  }

  const sequenceItems = sequenceDay.value || [];
  let roundNumber = 0;

  return (
    <Timeline orientation="left">
      {sequenceItems.map((sequenceItem, index) => {
        if (sequenceItem.type === 'round') {
          roundNumber += 1;
          const roundInfo = eventTemplate?.sequential_rounds?.find(
            (r) => r.id === sequenceItem.value.template_id,
          );

          return (
            <RoundTimelineItem
              key={`round-${roundNumber}-${index}`}
              roundNumber={roundNumber}
              roundInfo={roundInfo}
              index={index}
            />
          );
        }

        if (sequenceItem.type === 'break') {
          const breakAmount = sequenceItem.value?.amount || 0;
          const breakUnit = sequenceItem.value?.unit || t('mins', 'mins');

          return (
            <BreakTimelineItem
              key={`break-${index}`}
              breakAmount={breakAmount}
              breakUnit={breakUnit}
              index={index}
            />
          );
        }

        return null;
      })}
    </Timeline>
  );
};
